import { SimpleDialog, Typography } from '@nextiva/next-ui-components';
import React from 'react';

export function FileTypesDialogSupportingDocuments({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  return (
    <SimpleDialog
      open={open}
      title="Supported file format"
      confirmText="Done"
      confirmButtonProps={{
        color: 'primary',
        onClick: () => setOpen(false),
        'data-testid': 'PlatformAdminUI-CustomerConsent-DoneButton',
      }}
    >
      <Typography variant="body2" width="392px" mb={3}>
        Following are the supported file formats that you can upload: .bmp,
        .docx, .htm, .html, .jpeg, .jpg, .odt, .pdf, .png, .raw, .rtf, .tiff,
        .txt, .xml
      </Typography>
    </SimpleDialog>
  );
}

export function FileTypesDialogMms({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  return (
    <SimpleDialog
      open={open}
      title="Supported file format"
      confirmText="Done"
      confirmButtonProps={{
        color: 'primary',
        onClick: () => setOpen(false),
        'data-testid': 'PlatformAdminUI-CustomerConsent-DoneButton',
      }}
    >
      <Typography variant="body2" width="392px" mb={3}>
        Following are the supported file formats that you can upload: .3ga,
        .3gp, .amr, .avi, .bmp, .bz2, .cal, .css, .csv, .dib, .flac, .flv, .gif,
        .gz, .ico, .jpeg, .jpg, .js, .json, .m1a, .m1v, .m2a, .m4a, .m4b, .m4p,
        .m4r, .m4v, .mov, .mp1, .mp2, .mp3, .mp4, .mpa, .mpeg, .mpg, .mpv, .oga,
        .ogg, .ogm, .ogv, .ogx, .pdf, .pjpeg, .png, .qt, .rtf, .smil, .spx,
        .svg, .tar, .tif, .tiff, .txt, .vcard, .vcf, .wap, .wav, .webm, .webp,
        .wmv, .xml, .zip
      </Typography>
    </SimpleDialog>
  );
}
